module.exports = __webpack_public_path__ + "img/account-check.c6c3ea85.svg";